import { render, staticRenderFns } from "./confirm.component.vue?vue&type=template&id=ad7a2d32&scoped=true"
import script from "./confirm.component.vue?vue&type=script&lang=ts"
export * from "./confirm.component.vue?vue&type=script&lang=ts"
import style0 from "./confirm.component.vue?vue&type=style&index=0&id=ad7a2d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7a2d32",
  null
  
)

export default component.exports